<template>
   <ul role="list" class="divide-y divide-slate-200">
    <li v-for="item in items" :key="item.id" class="px-4 py-4 sm:px-0">
      <div class="flex items-center justify-between">
        <div class="flex flex-col">
          <a href="#" class="text-sm font-medium">{{ item.name }}</a>
        </div>
        <div class="flex items-center gap-x-4">
          <RouterLink :to="{ name: 'ShowProject', params: { customerId: item.customerId, projectId: item.id } }">
            <span class="text-sm font-medium text-primary hover:text-primary-dark">View</span>
          </RouterLink>
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { Project } from '@/models/project'

defineProps({
  items: {
    type: Array as PropType<Project[]>,
    required: true,
  },
})
</script>